import { forwardRef } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const CustomTypography = forwardRef((props, ref) => {
  const {
    variant = "body1",
    color,
    textAlign,
    gutterBottom = false,
    noWrap = false,
    paragraph = false,
    mb, mt, ml, mr,
    sx,
    ...rest
  } = props;

  const theme = useTheme();

  // Color value
  const colorValue = color ? theme.palette[color]?.main || color : undefined;

  return (
    <Typography
      ref={ref}
      variant={variant}
      color={colorValue}
      align={textAlign}
      gutterBottom={gutterBottom}
      noWrap={noWrap}
      paragraph={paragraph}
      sx={{
        color: colorValue,
        textAlign,
        ...(mb && { marginBottom: theme.spacing(mb) }), // Properly apply spacing
        ...(mt && { marginTop: theme.spacing(mt) }),
        ...(ml && { marginLeft: theme.spacing(ml) }),
        ...(mr && { marginRight: theme.spacing(mr) }),
        ...sx,
      }}
      {...rest}
    />
  );
});

CustomTypography.propTypes = {
  variant: PropTypes.oneOf([
    "h1", "h2", "h3", "h4", "h5", "h6",
    "subtitle1", "subtitle2",
    "body1", "body2",
    "button", "caption", "overline"
  ]),
  color: PropTypes.string,
  textAlign: PropTypes.oneOf(["left", "right", "center", "justify"]),
  gutterBottom: PropTypes.bool,
  noWrap: PropTypes.bool,
  paragraph: PropTypes.bool,
  sx: PropTypes.object,
};

export default CustomTypography;